import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../3rdPartyModules/_react-aria/focus/dist/useFocusRing-dee26278.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../3rdPartyModules/_react-aria/utils/dist/mergeProps-29aac069.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-701df069.js';
import { f as focusOutlineMixin } from '../FocusIndicator/styleMixins/focusOutline-ae6f4c7f.js';
import { k as keys } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-04a50e15-b033061a.js';
import { T as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-f853b17a.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-39f30e88.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-ea7cc233-62dc80e0.js';

const NodeSafeHTMLButtonElement = typeof HTMLButtonElement !== 'undefined' ? HTMLButtonElement : Object;
const normalStyles = /*#__PURE__*/css(["padding-top:", ";padding-bottom:", ";padding-inline-start:", ";padding-inline-end:", ";font-size:", ";", ""], ({
  theme
}) => theme.button.normal.paddingV, ({
  theme
}) => theme.button.normal.paddingV, ({
  theme
}) => theme.button.normal.paddingH, ({
  theme
}) => theme.button.normal.paddingH, ({
  theme
}) => theme.button.normal.fontSize, isMobile(css(["padding-top:", ";padding-bottom:", ";padding-inline-start:", ";padding-inline-end:", ";font-size:", ";"], ({
  theme
}) => theme.button.normal.mobile.paddingV, ({
  theme
}) => theme.button.normal.mobile.paddingV, ({
  theme
}) => theme.button.normal.mobile.paddingH, ({
  theme
}) => theme.button.normal.mobile.paddingH, ({
  theme
}) => theme.button.normal.mobile.fontSize)));
const smallStyles = /*#__PURE__*/css(["padding-top:", ";padding-bottom:", ";padding-inline-start:", ";padding-inline-end:", ";font-size:", ";", ""], ({
  theme
}) => theme.button.small.paddingV, ({
  theme
}) => theme.button.small.paddingV, ({
  theme
}) => theme.button.small.paddingH, ({
  theme
}) => theme.button.small.paddingH, ({
  theme
}) => theme.button.small.fontSize, isMobile(css(["padding-top:", ";padding-bottom:", ";padding-inline-start:", ";padding-inline-end:", ";font-size:", ";"], ({
  theme
}) => theme.button.small.mobile.paddingV, ({
  theme
}) => theme.button.small.mobile.paddingV, ({
  theme
}) => theme.button.small.mobile.paddingH, ({
  theme
}) => theme.button.small.mobile.paddingH, ({
  theme
}) => theme.button.small.mobile.fontSize)));
const StyledButton = /*#__PURE__*/styled('button').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    $focusVisible: isFocusVisible
  };
}).withConfig({
  componentId: "sc-storm-ui-30051113__sc-h8v7ib-0"
})(["", ";display:inline-block;position:relative;cursor:pointer;color:", ";padding-right:", ";padding-left:", ";background:", ";font-weight:normal;vertical-align:middle;border-width:1px;border-style:solid;border-color:", ";@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms ease;}z-index:", ";", ";:hover{cursor:", ";box-shadow:0 0 2px 1px ", ";background:", ";}", " :focus{", "}", ";}margin:0;"], ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.button.default.color, ({
  small
}) => small ? '10px' : '13px', ({
  small
}) => small ? '10px' : '13px', ({
  theme
}) => theme.button.default.bg, ({
  theme
}) => theme.button.default.borderColor, ({
  $focusVisible
}) => $focusVisible ? '1' : '0', ({
  small
}) => small ? smallStyles : normalStyles, ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer', ({
  theme
}) => theme.button.boxShadowFocus, ({
  theme
}) => theme.button.default.bgHover, ({
  theme,
  $isChecked
}) => $isChecked && `
    background: ${theme.button.group.bgActive};
    border: 1px solid #6c6e73;
    box-shadow: ${theme.button.group.boxShadowActive};
    color: ${theme.button.group.colorActive};

    :hover {
      box-shadow: ${theme.button.group.boxShadowActive};
      background: ${theme.button.group.bgActive};
    }
  `, ({
  $focusVisible
}) => $focusVisible && focusOutlineMixin, ({
  theme,
  disabled
}) => disabled && `
    cursor: not-allowed;
    outline: none;
    opacity: 1;
    color: ${theme.button.default.colorDisabled};
    border-color: ${theme.button.default.borderColorDisabled};
    background: ${theme.button.default.bgDisabled};
    pointer-events: all;
    /* ↑ override pointer-events rule for buttons */
    :hover {
      background: ${theme.button.default.bgDisabled};
    }
  `);
StyledButton.displayName = 'Wrapper';
class ButtonGroupItem extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleKeyUp", event => {
      const {
        key
      } = event;
      const {
        onChange = noop,
        value
      } = this.props;
      if (key === keys.ENTER || key === keys.SPACE) {
        onChange(value, event);
        event.preventDefault();
      }
    });
    _defineProperty(this, "handleChange", event => {
      const {
        onChange,
        value
      } = this.props;
      if (onChange) {
        /** TODO: Fix this type in Storm 4.x */
        onChange(value, event);
      }
    });
  }
  render() {
    const {
      id,
      value,
      isChecked,
      name,
      small,
      disabled,
      inputRef,
      children,
      taktId,
      taktValue,
      ...rest
    } = this.props;
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('button-group-item')
    }, ({
      getDataTaktAttributes
    }) => /*#__PURE__*/React__default.createElement(StyledButton, _extends({
      type: "button",
      id: id,
      role: "radio",
      "aria-checked": isChecked,
      $isChecked: isChecked,
      ref: inputRef,
      name: name,
      small: small,
      onClick: this.handleChange,
      onKeyUp: this.handleKeyUp,
      value: value,
      disabled: disabled,
      tabIndex: isChecked ? 0 : -1
    }, getDataTaktAttributes(), rest), children));
  }
}
_defineProperty(ButtonGroupItem, "propTypes", {
  /**
   * The id of the button element. This is set automatically by ButtonGroup.
   */
  id: PT.string,
  /**
   * The state indicating the button is active. This is set automatically by ButtonGroup.
   */
  isChecked: PT.bool,
  /**
   * Called when the user changes the component state. This is set automatically by ButtonGroup.
   */
  onChange: PT.func,
  /**
   * The name of the ButtonGroup this item belongs to. This is set automatically by ButtonGroup.
   */
  name: PT.string,
  /**
  * Determines size of button group.
  */
  small: PT.bool,
  /**
   * Red to the actual button element.
   */
  inputRef: PT.oneOfType([PT.func, PT.shape({
    current: PT.instanceOf(NodeSafeHTMLButtonElement)
  })]),
  /**
   * Text or icon of the button.
   */
  children: PT.node.isRequired,
  /**
   * The value returned when the button is clicked. This is set automatically by ButtonGroup.
   */
  value: PT.string.isRequired,
  /**
   * Set this to true to indicate the button is disabled
   */
  disabled: PT.bool
});
_defineProperty(ButtonGroupItem, "defaultProps", {
  inputRef: noop,
  id: undefined,
  isChecked: undefined,
  onChange: undefined,
  name: undefined,
  small: false,
  disabled: false
});

export { ButtonGroupItem as B };
//# sourceMappingURL=ButtonGroupItem-b65236c9.js.map
